import Vue from 'vue';

// Flow definitions - Each flow is an ordered array of page components
export const FLOWS = {
    REFI: [
        { comp: 'RefinanceElegible', url: 'eligible' }, 
        { comp: 'RefinanceConfiguration', url: 'refi-configuration' }, 
        { comp: 'RefinanceConfirmation', url: 'refi-confirmation' }, 
        { comp: 'RefinanceComplete', url: 'refi-complete' }
    ],
    NEW_LOAN: [
        { comp: 'NewLoanOffer', url: 'new-loan-offer' }, 
        { comp: 'NewLoanConfirmation', url: 'new-loan-confirmation' }, 
        { comp: 'NewLoanComplete', url: 'new-loan-complete' }
    ],
    TEMP_UNAVAILABLE: [
        { comp: 'RefinanceTemporaryUnavailable', url: 'temporary-unavailable' }
    ],
    UNAVAILABLE: [
        { comp: 'RefinanceUnavailable', url: 'unavailable' }
    ],
    NO_PAYROLL: [
        { comp: 'RefinanceNoPayroll', url: 'no-payroll' }
    ],
};

export const RefinanceStore = Vue.observable({
    currentPage: '',
    currentFlowName: '',
    data: {}, // Where all props and user inputs are stored
    submissionLocked: false,

    // Initialization with data from Backend/Blade
    init(initialProps) {
        this.data = { ...initialProps };
    },

    setFlow(flowName) {
        this.currentFlowName = flowName;
        const flow = FLOWS[flowName];

        // On reload, restore the step matching the current hash if it belongs to this flow
        const currentHash = window.location.hash.replace('#', '');
        const matchedStep = flow.find(s => s.url === currentHash);

        if (matchedStep) {
            this.currentPage = matchedStep.comp;
        } else {
            this.updateState(flow[0], true);
        }
    },

    next() {
        const flow = FLOWS[this.currentFlowName];
        
        const currentIndex = flow.findIndex(step => step.comp === this.currentPage);
        const nextStep = flow[currentIndex + 1];

        if (nextStep) {
            this.updateState(nextStep);
        }
    },

    updateState(step, replace = false) {
        console.log(`Navigating to ${step.comp} (URL: #${step.url})`);
        this.currentPage = step.comp;
        const url = '#' + step.url;

        // Defer URL update so it runs after all synchronous click handlers
        // (including any href="#" default navigation) have completed
        window.setTimeout(() => {
            if (replace) {
                window.history.replaceState({ comp: step.comp }, '', url);
            } else {
                window.history.pushState({ comp: step.comp }, '', url);
            }
        }, 0);
    },

    prev() {
        const flow = FLOWS[this.currentFlowName];
        const currentIndex = flow.findIndex(step => step.comp === this.currentPage);
        const prevStep = flow[currentIndex - 1];

        if (prevStep) {
            this.updateState(prevStep);
        }
    },

    // After a successful submission, prevent the browser back button from
    // returning to earlier flow pages. The wizard's own popstate handler
    // checks this flag and pushes the completion page back instead.
    lockNavigation() {
        // Defer so this runs after updateState's own setTimeout(0) pushState
        window.setTimeout(() => {
            this.submissionLocked = true;
        }, 0);
    },

    unlockNavigation() {
        this.submissionLocked = false;
    },

    // Updates data (e.g., cashback slider) from any page
    update(newData) {
        this.data = { ...this.data, ...newData };
    },

    getData() { 
        return this.data;
    },
});